module.exports = __webpack_public_path__ + "static/media/CAMLEVERORSDS700.4bca2d05.jpg";